import fetch from "lib/fetch";
import type { ActivityInterface } from "types/reference";

type ActivityListResponse = { data: Array<ActivityInterface> };

export const getActivitiesRequest = (languageCode: string) =>
    fetch.get<ActivityListResponse>(`reference/activity/${languageCode}`);
